import { createAsyncThunk } from "@reduxjs/toolkit";
import * as paymentApi from "../../api/paymentApi";

const errMsg = (err, fallback) =>
  err?.response?.data?.message || err?.message || fallback;

export const fetchCurrentPlan = createAsyncThunk(
  "payment/fetchCurrentPlan",
  async (userId, { rejectWithValue }) => {
    try {
      return await paymentApi.getCurrentPlan(userId);
    } catch (err) {
      return rejectWithValue(errMsg(err, "Failed to load current plan"));
    }
  }
);

export const fetchSubscription = createAsyncThunk(
  "payment/fetchSubscription",
  async (userId, { rejectWithValue }) => {
    try {
      return await paymentApi.getSubscription(userId);
    } catch (err) {
      return rejectWithValue(errMsg(err, "Failed to load subscription"));
    }
  }
);

export const fetchPaymentHistory = createAsyncThunk(
  "payment/fetchPaymentHistory",
  async (userId, { rejectWithValue }) => {
    try {
      return await paymentApi.getPaymentHistory(userId);
    } catch (err) {
      return rejectWithValue(errMsg(err, "Failed to load payment history"));
    }
  }
);

export const initiatePayment = createAsyncThunk(
  "payment/initiatePayment",
  async ({ userId, plan, billingCycle, userType = "patient" }, { rejectWithValue }) => {
    try {
      return await paymentApi.initiatePayment({ userId, userType, plan, billingCycle });
    } catch (err) {
      return rejectWithValue(errMsg(err, "Failed to start Flouci checkout"));
    }
  }
);

export const confirmPayment = createAsyncThunk(
  "payment/confirmPayment",
  async (flouciPaymentId, { rejectWithValue }) => {
    try {
      return await paymentApi.confirmPayment(flouciPaymentId);
    } catch (err) {
      return rejectWithValue(errMsg(err, "Failed to confirm payment"));
    }
  }
);

export const cancelSubscription = createAsyncThunk(
  "payment/cancelSubscription",
  async (userId, { rejectWithValue }) => {
    try {
      await paymentApi.cancelSubscription(userId);
      return userId;
    } catch (err) {
      return rejectWithValue(errMsg(err, "Failed to cancel subscription"));
    }
  }
);
